import React from "react"
import Dropdown from "../../../../Dropdown/Dropdown"
import { options } from "./options"
import { setProfessionType } from "../../useReducer/actionCreators"
import useOption from "./useOption"

const ProfessionDropdown = ({ externalDispatch, selectedType }) => {
  const [option, setOption] = useOption(selectedType)
  return (
    <Dropdown
      label="Profession"
      id="profession_type_dropdown"
      options={options}
      value={option}
      onChange={(option) => {
        setOption(option)
        externalDispatch(setProfessionType(option.id))
      }}
    />
  )
}
export default ProfessionDropdown
